angular.
module("dx.webapp.student").
controller("DxStudentSearchRouteController", function StudentSearchRouteController(
	$location,
	$rootScope,
	$scope,

	DX_ACCESSIBILITY_FILTER_SETTINGS,
	DX_STUDENT_SORT_PREDICATE,
	DX_URLS,
	NodeRepository,
	RoleTypeEnum,
	dxApi,
	dxBitFlagsHelper,
	dxEvent,
	dxSession,
	dxSorting,

	dxLocalize,
	DX_KEY_CODES,
	dxAngularConstantHelper
) {
	"use strict";

	var self = this;

	var previousUrlQuery;
	var DX_EVENT_NAME = dxAngularConstantHelper.DX_EVENT_NAME;

	self.role = dxSession.getRole();
	self.RoleTypeEnum = RoleTypeEnum;
	self.DX_STUDENT_SORT_PREDICATE = DX_STUDENT_SORT_PREDICATE;

	self.studentResults = null;
	self.query = "";
	self.isFreemium = false;

	self.accessibilityFiltersDisplayed = false;
	self.filterEnabled = false;
	self.filterModel = {
		spellCheck: false,
		textToSpeech: false,
		extendedTime: false,
		audioFiles: false,
		immersiveReader: false,
		disableFilters: false,
	};

	self.sortOptions = {
		predicate: "",
		reverse: false,
	};

	NodeRepository.load(self.role.organizationId).then(onNodeLoadSuccess);

	dxEvent.create(DX_EVENT_NAME.PageviewStudentSearch);

	function onNodeLoadSuccess(node) {
		self.node = node;
		self.all = false;
		self.byEmailCode = false;

		$scope.$on("$routeUpdate", updateQuery);

		$scope.$watch("vm.query", function watchVmQuery(newVal) {
			// Needs to be set to null for $location.search to remove the query parameter from the URL
			updateParameters("query", newVal || null);
		});

		$scope.$watch("vm.filterModel", function watchFilter() {
			// Needs to be set to null for $location.search to remove the query parameter from the URL
			var filterBit = getAccessibilityFilterBit();
			self.filterEnabled = !!filterBit;
			updateParameters("filter", !filterBit && !self.filterModel.disableFilters ? null : filterBit);
		}, true);

		if (self.node.freemium) {
			unauthorized();
		} else {
			updateQuery();
		}
	}

	function updateParameters(param, val) {
		$location.search(param, val);

		// Avoid resetting sort parameter when backing up from another page or reloading the page
		if (self.sortOptions.predicate) {
			$location.search("sort", null);
			self.sortOptions.predicate = "";
			self.sortOptions.reverse = false;
		}
	}

	self.navigateToStudent = function navigateToStudent(id) {
		$location.path(DX_URLS.get("student", {id: id}));
		$location.search({});
	};

	self.displayAccessibilityFilters = function displayAccessibilityFilters() {
		self.accessibilityFiltersDisplayed = true;
	};

	self.hideAccessibilityFilters = function hideAccessibilityFilters() {
		self.accessibilityFiltersDisplayed = false;
	};

	self.updateSort = function updateSort(predicate) {
		if (!self.studentResults) {
			return;
		}

		var sortParameter = predicate;

		if (self.sortOptions.predicate === predicate && !self.sortOptions.reverse) {
			sortParameter = "-" + sortParameter;
		}

		$location.search("sort", sortParameter);
	};

	function sortStudents() {
		var predicate = $location.search().sort;

		if (predicate) {
			if (predicate[0] === "-") {
				self.sortOptions.reverse = true;
				predicate = predicate.substr(1);
			} else {
				self.sortOptions.reverse = false;
			}

			self.sortOptions.predicate = predicate;
			if (self.studentResults && self.studentResults.hits) {
				self.studentResults.hits = dxSorting.studentSearchSort(self.studentResults.hits, self.sortOptions);
			}
		} else {
			self.sortOptions.predicate = "";
			self.sortOptions.reverse = false;
		}
	}

	self.onTableRowKeyDown = function onTableRowKeyDown(event, id) {
		if (event.keyCode !== DX_KEY_CODES.enter && event.keyCode !== DX_KEY_CODES.space) {
			return;
		}
		event.preventDefault();

		self.navigateToStudent(id);
	};

	self.navigateToChangeStudentCode = function navigateChangeStudentCode() {
		$location.path(DX_URLS.get("changeStudentCode"));
	};

	self.navigateToImportStudents = function navigateToImportStudents() {
		$location.path(DX_URLS.get("importStudents"));
	};

	self.navigateToCreateStudent = function navigateToCreateStudent() {
		$location.path(DX_URLS.get("createStudent"));
	};

	self.navigateToDeleteStudents = function navigateToDeleteStudents() {
		$location.path(DX_URLS.get("deleteStudents"));
	};


	self.showAllStudents = function showAllStudents() {
		// eslint-disable-next-line
		var input = angular.element(document.querySelector("#studentSearchField"));
		input[0].value = "all=";
		this.query = "all=";
	};

	self.showStudentsEmailCode = function showStudentsEmailCode() {
		// eslint-disable-next-line
		var input = angular.element(document.querySelector("#studentSearchField"));
		// eslint-disable-next-line block-scoped-var
		input[0].value = "all:emailcode=";
		this.query = "all:emailcode=";
	};

	function unauthorized() {
		$rootScope.$broadcast("notification:warning", dxLocalize.get("StudentSearch.Unauthorized"));

		self.isFreemium = true;

		switch (self.role.roleType) {
			case self.RoleTypeEnum.ACCOUNTMANAGER:
				$location.path(DX_URLS.get("roles", {id: self.role.organizationId}));
				break;
			case self.RoleTypeEnum.ADMIN:
			case self.RoleTypeEnum.TEACHER:
				$location.path(DX_URLS.get("overview"));
				break;
			default:
				$location.path(DX_URLS.get("login"));
		}
	}

	function shouldSort(newUrlQuery) {
		if (!previousUrlQuery) {
			return false;
		}

		var unchangedSearch = previousUrlQuery.query === newUrlQuery.query &&
			previousUrlQuery.filter === newUrlQuery.filter;
		var sortChanged = newUrlQuery.sort && previousUrlQuery.sort !== newUrlQuery.sort;

		return unchangedSearch && sortChanged;
	}

	function updateQuery() {
		var urlQuery = $location.search();
		self.all = false;
		self.byEmailCode = false;

		// When exiting the view and using the back button to go back while still having a filter query parameter,
		// location.search converts filter to a string, assure that it's still an int in this edge case.
		if (typeof urlQuery.filter === "string") {
			urlQuery.filter = parseInt(urlQuery.filter, 10);
		}

		if (shouldSort(urlQuery)) {
			sortStudents();
			previousUrlQuery = angular.copy(urlQuery);
			return;
		}

		// In case we are going backwards we clear sort options
		self.sortOptions.predicate = "";
		self.sortOptions.reverse = false;

		previousUrlQuery = angular.copy(urlQuery);

		if (urlQuery.filter !== getAccessibilityFilterBit()) {
			updateAccessibilityFilter(urlQuery.filter);
		}

		if (urlQuery.query) {
			if (urlQuery.query === "all=") {
				self.all = true;
			}

			if (urlQuery.query === "all:emailcode=") {
				self.byEmailCode = true;
			}

			self.query = urlQuery.query;
			studentSearch(urlQuery);
		} else {
			self.studentResults = null;
			self.query = "";
		}
	}

	function studentSearch(urlQuery) {
		dxApi.v1.studentinfo.get(urlQuery.query, urlQuery.filter, self.node.disabledStudentCodes, self.all, self.byEmailCode).then(success, error);


		function success(response) {
			self.studentResults = response.data;
			sortStudents();
		}

		function error() {
			$rootScope.$broadcast("notification:error", dxLocalize.get("StudentSearchUnavailable"));
		}
	}

	function updateAccessibilityFilter(settings) {
		if (settings === 0) {
			self.filterModel.disableFilters = true;
		} else if (settings > 0) {
			self.filterModel.textToSpeech = dxBitFlagsHelper.isBitIncluded(settings, DX_ACCESSIBILITY_FILTER_SETTINGS.TEXT_TO_SPEECH);
			self.filterModel.spellCheck = dxBitFlagsHelper.isBitIncluded(settings, DX_ACCESSIBILITY_FILTER_SETTINGS.SPELL_CHECK);
			self.filterModel.extendedTime = dxBitFlagsHelper.isBitIncluded(settings, DX_ACCESSIBILITY_FILTER_SETTINGS.EXTENDED_TIME);
			self.filterModel.audioFiles = dxBitFlagsHelper.isBitIncluded(settings, DX_ACCESSIBILITY_FILTER_SETTINGS.AUDIO_FILES);
			self.filterModel.immersiveReader = dxBitFlagsHelper.isBitIncluded(settings, DX_ACCESSIBILITY_FILTER_SETTINGS.IMMERSIVE_READER);
			self.filterModel.disableFilters = false;
		} else {
			self.filterModel.textToSpeech = false;
			self.filterModel.spellCheck = false;
			self.filterModel.extendedTime = false;
			self.filterModel.audioFiles = false;
			self.filterModel.immersiveReader = false;
			self.filterModel.disableFilters = false;
		}
	}

	function getAccessibilityFilterBit() {
		var accessibilitySettings = 0;

		if (self.filterModel.disableFilters) {
			return accessibilitySettings;
		}

		if (self.filterModel.textToSpeech) {
			accessibilitySettings += DX_ACCESSIBILITY_FILTER_SETTINGS.TEXT_TO_SPEECH;
		}

		if (self.filterModel.spellCheck) {
			accessibilitySettings += DX_ACCESSIBILITY_FILTER_SETTINGS.SPELL_CHECK;
		}

		if (self.filterModel.extendedTime) {
			accessibilitySettings += DX_ACCESSIBILITY_FILTER_SETTINGS.EXTENDED_TIME;
		}

		if (self.filterModel.audioFiles) {
			accessibilitySettings += DX_ACCESSIBILITY_FILTER_SETTINGS.AUDIO_FILES;
		}

		if (self.filterModel.immersiveReader) {
			accessibilitySettings += DX_ACCESSIBILITY_FILTER_SETTINGS.IMMERSIVE_READER;
		}

		return accessibilitySettings;
	}
});
